<div class="container my-4 pb-4">
    <h3>{{ 'search.title' | translate }}</h3>
    <p>{{ 'search.description' | translate }}</p>

    <app-filters-info [documents]="documents"></app-filters-info>
    <!-- Add *ngIf="withResults" before commiting -->
    <app-documents *ngIf="showDocuments()" (syncDocuments)="loadDocuments()"
        (sendButtonInfo)="handleButtonAction($event)" [tableData]="documents"></app-documents>
</div>

<app-mail-sender #mailSender [loading]="loading" (onSend)="sendDocs($event)"></app-mail-sender>

<iframe *ngIf="pdfToPrint" #iframe id="print" width="420" height="345" [src]="pdfToPrint | safe">
</iframe>

<app-delete-confirmation (send)="deleteDocumentsSign($event)" [SignedDocument]="withResults"></app-delete-confirmation>
<app-confirmation-modal [type]="confirmationType" (confirm)="onConfirm($event)"></app-confirmation-modal>

<!-- <pdf-viewer #pdfViewerOnDemand [externalWindow]="true" [downloadFileName]="'documents.pdf'" [openFile]="false"
    [viewBookmark]="false" [download]="false"></pdf-viewer> -->
    <pdf-viewer #pdfViewerOnDemand [src]="pdfTemp | safe" [render-text]="true" [original-size]="false" [show-all]="true"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false" style="width: 100%; height: 100vh;"></pdf-viewer>